import { useCallback, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import theme from 'theme_'
import {
  ModalButtonsWrap,
  ModalText,
  ModalTitle,
} from 'components/Modal/styles'
import { H2, Regular, SectionLabel } from 'components/Typography'
import { CommonButton } from 'components/Button'
import { LoaderOverlay } from 'components/Loader'

import {
  ChangePassModalContainer,
  ChangePassBtnWrap,
  ChangePassInstructionsBlock,
  ChangePassIconWrap,
} from './styles'
import { CheckCircleOutline } from 'components/Icons'
import {
  currentUserSelector,
  passInitResetSelectors,
} from 'features/auth/login/selectors'
import BaseModal from 'components/Modal/BaseModal'
import { WhiteBlock } from 'components/Layout'
import { myAccountMessages } from '../messages'
import { passInitResetThunk } from 'features/auth/login/slice'
import { loginMessages } from 'features/auth/login/messages'

function ChangePassword() {
  const dispatch = useAppDispatch()
  const { formatMessage } = useIntl()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [setIsModalOpen])

  const isPassResetLoading = useAppSelector(passInitResetSelectors.isFetching)

  const { email } = useAppSelector(currentUserSelector)

  const handleChange = useCallback(() => {
    dispatch(
      passInitResetThunk({
        email,
        onSuccess: () => {
          setIsModalOpen(true)
        },
      })
    )
  }, [dispatch, email])

  return (
    <>
      {isPassResetLoading && <LoaderOverlay />}
      <BaseModal isOpen={isModalOpen} onRequestClose={closeModal}>
        <ChangePassModalContainer>
          <ChangePassIconWrap>
            <CheckCircleOutline />
          </ChangePassIconWrap>
          <ModalTitle>
            <H2>{formatMessage(myAccountMessages.changePassModalHeading)}</H2>
          </ModalTitle>
          <ModalText>
            {formatMessage(myAccountMessages.changePassModalText)}
          </ModalText>
          <ModalButtonsWrap>
            <CommonButton onClick={closeModal}>
              <FormattedMessage {...myAccountMessages.changePassModalClose} />
            </CommonButton>
          </ModalButtonsWrap>
        </ChangePassModalContainer>
      </BaseModal>
      <WhiteBlock>
        <SectionLabel color={theme.colors.mutedGray}>
          <FormattedMessage {...myAccountMessages.changePassword} />
        </SectionLabel>
        <ChangePassInstructionsBlock>
          <Regular>
            {formatMessage(myAccountMessages.changePassInstructions)}
          </Regular>
        </ChangePassInstructionsBlock>
        <ChangePassBtnWrap>
          <CommonButton onClick={handleChange} variant="secondary">
            <FormattedMessage {...loginMessages.sendEmailButton} />
          </CommonButton>
        </ChangePassBtnWrap>
      </WhiteBlock>
    </>
  )
}

export default ChangePassword
